@if (isLoader) {
  <bmcore-loader></bmcore-loader>
}

@if (!isLoader) {
  @for (track of tracks; track track) {
    <bmcore-track-item
      [track]="track"
      [isShowFavBtn]="true"
      (setPlaylistEvent)="setPlaylist()"
      [appType]="'BMSTV'"
      [ordinalNumber]="track.ordinalNumber"
    >
    </bmcore-track-item>
  }
  @if (showNotFavTracksMessage) {
    <bmcore-beats-not-found [title]="' No beats were found!'"></bmcore-beats-not-found>
  }
}
